import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-opacity": ".5",
      d: "M1.156 1.91c-.124-.384-.187-.575-.141-.693a.35.35 0 0 1 .227-.21c.12-.033.3.05.661.215L13.38 6.49c.353.162.53.243.584.355a.36.36 0 0 1 0 .31c-.054.113-.23.194-.584.356L1.907 12.778c-.362.165-.543.248-.662.214a.35.35 0 0 1-.228-.21c-.045-.118.018-.31.144-.693l1.603-4.884a1 1 0 0 0 .036-.132.4.4 0 0 0 0-.09c-.004-.034-.014-.067-.036-.133z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6.598 7H2.822m-.058.205L1.16 12.089c-.126.383-.19.575-.144.694.04.102.124.18.228.21.12.034.3-.05.662-.216L13.38 7.512c.353-.162.53-.243.584-.355a.36.36 0 0 0 0-.31c-.054-.113-.23-.194-.584-.356L1.903 1.222c-.36-.166-.541-.248-.66-.214a.35.35 0 0 0-.228.209c-.046.118.017.31.141.692L2.764 6.85c.022.066.032.099.037.133q.004.045 0 .09a1 1 0 0 1-.037.132"
    }, null, -1)
  ])))
}
export default { render: render }